import {Tag} from 'antd';
import React from 'react';
import {reviewApproverTypeConstants} from '../../constants';

const {ANY_ADMIN, AUTO_APPROVAL} = reviewApproverTypeConstants;

export const reviewHelpers = {
  isEmployeeInApprovalList: (data, employeeEmail) => {
    if (!data || !employeeEmail) return false;
    return (data?.approval || []).some(review => review.approver?.email === employeeEmail);
  },
  isAlreadyApprovedByEmployee: (data, employeeEmail) => {
    if (!data || !employeeEmail) return false;
    return (data?.approval || []).some(review => review.approver?.email === employeeEmail && Boolean(review?.approval_date));
  },
  isAlreadyApprovedByAdmin: (data) => {
    if (!data) return false;
    return (data?.approval || []).some(review => review?.admin_override && Boolean(review?.approval_date));
  },
  isAnyAdminApproval: (expense) => {
    if (!expense || !Array.isArray(expense.approval)) return false;
    return expense.approval.some(review => review.approver?.email === ANY_ADMIN);
  },
  isAutoApproval: (expense) => {
    if (!expense || !Array.isArray(expense.approval)) return false;
    return expense.approval.some(review => review.approver?.email === AUTO_APPROVAL);
  },
  getApprovals: (data) => (data?.approval || []).filter(review => ![AUTO_APPROVAL, ANY_ADMIN].includes(review.approver?.email)),
  getAnyAdminApprovals: (data) => (data?.approval || []).filter(review => review.approver?.email === ANY_ADMIN),
  getAutoApprovals: (data) => (data?.approval || []).filter(review => review.approver?.email === AUTO_APPROVAL),
  getAdminOverrideApproval: (data) => {
    if (!data || !Array.isArray(data.approval)) return null;
    return (data?.approval || []).find(review => review?.admin_override && Boolean(review?.approval_date)) || null;
  },
  canQuickApprove: ({ data, employeeEmail, isAdmin = true }) => {
    if (!data) return false;
    if (isAdmin && reviewHelpers.isAnyAdminApproval(data)) return true;
    return data?.approval?.length === 1 && data.approval[0]?.approver?.email === employeeEmail;
  },
  getStatusLabel: ({value, t, statuses} = {}) => {
    if (!value) return null;
    const statusProps = statuses[value] || {};
    return (
      <Tag style={{
        backgroundColor: statusProps.backgroundColor || '#F3F3F4',
        borderColor: statusProps.backgroundColor ? 'transparent' : '#CDD0D5',
        borderRadius: 16,
        color: statusProps.color || '#9CA1AA',
        height: 24,
        marginRight: 0
      }}>{statusProps.key ? t(statusProps.key) : 'Undefined'} </Tag>
    );
  },
}
